import React from 'react';
import type { Lang, TranslationKey } from '../i18n';

type LegalPage = 'mentions' | 'privacy' | 'cgv';

interface FooterProps {
    t: (key: TranslationKey) => string;
    onLegalClick?: (page: LegalPage) => void;
}

const Footer: React.FC<FooterProps> = ({ t, onLegalClick }) => {
    return (
        <footer className="pricing-footer">
            <div className="footer-inner">
                <a href="https://bitek.fr" target="_blank" rel="noopener noreferrer" className="footer-promo">
                    {t('footer.promo')}
                </a>
                <nav className="footer-links">
                    <a href="#mentions" onClick={(e) => { e.preventDefault(); onLegalClick?.('mentions'); }}>
                        {t('footer.legalNotice')}
                    </a>
                    <a href="#privacy" onClick={(e) => { e.preventDefault(); onLegalClick?.('privacy'); }}>
                        {t('footer.privacy')}
                    </a>
                    <a href="#cgv" onClick={(e) => { e.preventDefault(); onLegalClick?.('cgv'); }}>
                        {t('footer.terms')}
                    </a>
                </nav>
                <p className="footer-copy">© {new Date().getFullYear()} {t('footer.copyright')}</p>
            </div>
        </footer>
    );
};

export default Footer;
